import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=43903177&scoped=true&lang=pug&"
import script from "./Box.vue?vue&type=script&lang=ts&"
export * from "./Box.vue?vue&type=script&lang=ts&"
import style0 from "./Box.vue?vue&type=style&index=0&id=43903177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43903177",
  null
  
)

export default component.exports